"use client";

import * as React from "react";
import * as SwitchPrimitives from "@radix-ui/react-switch";

import { cn } from "@/lib/utils";

export interface SwitchProps
  extends React.ComponentPropsWithoutRef<typeof SwitchPrimitives.Root> {
  // Accepted for backwards compatibility; visual styling is now token-driven.
  variant?: string;
  size?: string;
}

const Switch = React.forwardRef<
  React.ElementRef<typeof SwitchPrimitives.Root>,
  SwitchProps
>(({ className, variant: _variant, size: _size, ...props }, ref) => (
  <SwitchPrimitives.Root
    className={cn(
      "peer relative inline-flex h-[18px] w-[30px] shrink-0 cursor-pointer items-center rounded-full transition-[transform,background-color] duration-[var(--duration-short-4)] ease-[var(--ease-emphasized)] motion-reduce:transition-none hover:data-[state=unchecked]:bg-surface-2 hover:data-[state=checked]:bg-primary-hover active:scale-[0.97] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background data-[state=checked]:bg-primary data-[state=unchecked]:bg-surface-3 disabled:opacity-60 disabled:cursor-not-allowed disabled:pointer-events-none",
      className,
    )}
    {...props}
    ref={ref}
  >
    <SwitchPrimitives.Thumb
      className={cn(
        "pointer-events-none block size-3.5 rounded-full bg-background shadow-[var(--elev-1)] transition-transform duration-[var(--duration-short-4)] ease-[var(--ease-emphasized)] motion-reduce:transition-none data-[state=checked]:translate-x-3.5 data-[state=unchecked]:translate-x-0.5",
      )}
    />
  </SwitchPrimitives.Root>
));
Switch.displayName = SwitchPrimitives.Root.displayName;

export { Switch };
